
import React from 'react';

interface BlogEmptyStateProps {
  searchQuery?: string;
  onClearSearch?: () => void;
}

const BlogEmptyState: React.FC<BlogEmptyStateProps> = ({ searchQuery, onClearSearch }) => {
  if (searchQuery) {
    return (
      <div className="py-16 text-center">
        <p className="text-xl text-gray-600">No posts found matching your search.</p>
        {onClearSearch && (
          <button
            onClick={onClearSearch}
            className="mt-4 text-[#C46829] hover:text-[#B35718] font-medium"
          >
            Clear search
          </button>
        )}
      </div>
    );
  }
  
  return (
    <div className="py-16 text-center">
      <h2 className="text-2xl font-bold mb-4">No Blog Posts Available</h2>
      <p className="text-gray-600">Check back soon for new stories and updates!</p>
    </div>
  );
};

export default BlogEmptyState;
